<template>
    <div class="correct-exam">
        <manage-title>考试阅卷</manage-title>
        <el-form class="form xy-between" inline>
            <div>
                <el-form-item>
                    <medical-class-selector
                        v-model="query.classId"
                        @change="loadData(true)"
                    ></medical-class-selector>
                </el-form-item>
                <el-form-item>
                    <el-select
                        v-model="query.examType"
                        placeholder="请选择类型"
                        clearable
                        @change="loadData(true)"
                    >
                        <el-option label="考试" :value="1" />
                        <el-option label="作业" :value="2" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input
                        v-model="query.examName"
                        placeholder="请输入关键字检索..."
                        style="width:300px;margin:0 -20px 0 20px;"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="loadData(true)"
                        >检索</el-button
                    >
                </el-form-item>
            </div>
            <!-- <div class="xy-start">
                <el-form-item>
                    <el-input
                        v-model="query.examName"
                        placeholder="请输入关键字检索..."
                    ></el-input>
                </el-form-item>
                <el-button type="primary" @click="loadData(true)"
                    >检索</el-button
                >
            </div> -->
        </el-form>
        <el-table :data="list" class="pv-48" v-loading="loading">
            <el-table-column label="考试名称" prop="ExamName" />
            <el-table-column label="类型">
                <template v-slot="scope">
                    {{ parseInt(scope.row.ExamType) === 1 ? "考试" : "作业" }}
                </template>
            </el-table-column>
            <el-table-column label="分类" prop="ClassName" />
            <el-table-column label="考试时间" min-width="130">
                <div slot-scope="scope">
                    <div>{{ scope.row.BeginTime.slice(0, 16) }}</div>
                    <div>{{ scope.row.EndTime.slice(0, 16) }}</div>
                </div>
            </el-table-column>
            <el-table-column label="答卷时长">
                <template v-slot="scope">
                    <div v-if="parseInt(scope.row.ExamTime) === 0">
                        不限时长
                    </div>
                    <div v-else>{{ scope.row.ExamTime }}分钟</div>
                </template>
            </el-table-column>
            <el-table-column label="已评试卷" prop="HaveScore" min-width="100" />
            <el-table-column label="待评试卷" prop="NoScore" min-width="100" />
            <el-table-column label="操作" fixed="right">
                <template v-slot="{ row }">
                    <el-button
                        @click="correct(row)"
                        type="primary"
                        v-if="row.IsMarkAuthorize !== false"
                        size="mini"
                        >进入阅卷</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="xy-center pv-16 container">
            <el-pagination
                @current-change="loadData()"
                @size-change="loadData(true)"
                :current-page.sync="query.pageNo"
                :page-size.sync="query.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                hide-on-single-page
                :total="total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import ManageTitle from "@/components/manager/ManageTitle";
import MedicalClassSelector from "@/components/manager/MedicalClassSelector";
import { cleanNoneParam } from "@/utils";
import { MarkExamPaper } from "@/api/manage";

export default {
    name: "correct-exam",
    components: { MedicalClassSelector, ManageTitle },
    data() {
        return {
            query: {
                classId: "",
                examType: "",
                examName: "",
                pageNo: 1,
                pageSize: 10
            },
            loading: false,
            list: [],
            total: 0
        };
    },
    created() {
        this.loadData();
    },
    methods: {
        correct(item) {
            this.$router.push({
                name: "correct-exam2",
                query: {
                    id: item.ExamId
                }
            });
        },
        loadData(refresh) {
            if (refresh === true) {
                this.query.pageNo = 1;
            }
            let query = cleanNoneParam(this.query);
            this.loading = true;
            MarkExamPaper(query)
                .then(({ data }) => {
                    this.list = data.data;
                    this.total = data.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>

<style scoped lang="less">
.form {
    padding: 20px;
}
.pv-48 {
    padding: 0 30px;
}
</style>
